// Chile en Cartas — theme.js
// Handles: FAQ accordion, quantity buttons, total price update on quantity change,
// cart auto-update on quantity change.

document.addEventListener('DOMContentLoaded', function () {

  // ===== FAQ accordion toggle =====
  // New: data-faq-toggle attribute
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.parentElement.classList.toggle('open');
    });
  });

  // Legacy support for inline onclick="toggleFAQ(this)"
  window.toggleFAQ = function (el) {
    el.parentElement.classList.toggle('open');
  };

  // ===== Quantity +/- buttons =====
  document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var change = parseInt(btn.getAttribute('data-qty-change'), 10);
      var form = btn.closest('form');
      var input = form
        ? form.querySelector('input[name="quantity"], input[name^="updates"]')
        : null;
      if (!input) {
        input = btn.parentElement.querySelector('input[type="number"]');
      }
      if (!input) return;

      var min = parseInt(input.min || '0', 10);
      var current = parseInt(input.value, 10) || 1;
      var next = Math.max(min, current + change);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ===== Update displayed total when quantity changes =====
  document.querySelectorAll('form[id*="product-form"], form[id*="compra-form"]').forEach(function (form) {
    var qtyInput = form.querySelector('input[name="quantity"]');
    var totalEl = form.querySelector('[data-cart-total]');
    if (!qtyInput || !totalEl) return;

    var initial = totalEl.textContent.replace(/[^0-9]/g, '');
    var unitPrice = parseInt(initial, 10);
    if (!unitPrice) return;

    var formatCLP = function (n) {
      return '$' + n.toLocaleString('es-CL');
    };

    qtyInput.addEventListener('change', function () {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      totalEl.textContent = formatCLP(unitPrice * qty);
    });
  });

  // ===== Cart page: auto-submit when qty changes =====
  document.querySelectorAll('form[action*="/cart"] input[name^="updates"]').forEach(function (input) {
    var debounce = null;
    input.addEventListener('change', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        input.form.submit();
      }, 600);
    });
  });

});
